import {useState} from "react"

const SATE_SAVE_KEY = "cta"
const INIT = {disabled: false, unset: []}

export const useHelpCta = () => {
    const [state, setState] = useState(loadState)

    const setStateAndSave = (newState) => {
        setState(prevState => {
            newState = {...prevState, ...newState}
            saveState(newState)
            return newState
        })
    }

    const reset = () => {
        setStateAndSave(INIT)
    }

    const disable = () => {
        setStateAndSave({disabled: true})
    }

    const unset = (name) => {
        setStateAndSave({unset: [...state.unset, name]})
    }

    const canShow = (name) => {
        return state.disabled === false && state.unset.includes(name) === false
    }

    return {reset, disable, unset, canShow}
}


const loadState = () => {
    return sessionStorage.getItem(SATE_SAVE_KEY)
        ? JSON.parse(sessionStorage.getItem(SATE_SAVE_KEY))
        : INIT
}

const saveState = (value) => {
    sessionStorage.setItem(SATE_SAVE_KEY, JSON.stringify(value))
}
